import { AVAILABLE_ENTITIES, Repository, utils } from '../../database'
import { FAZENDA, formatName } from '../../utils/formHelper'
import React, { Component } from 'react'

import AppContent from '../../components/layout/AppContent'
import FarmForm from './components/FarmForm'
import Prompt from '../../components/Prompt'
import TitleBar from '../../components/TitleBar'
import TopBar from '../../components/TopBar'
import difference from 'lodash/difference'
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import { getLoggedUser } from '../../redux/auth/actions'
import {
  recordError,
  recordEvent,
  recordSaveOutcome,
} from '../../observability/events'
import { verify } from './../../utils/verifyDuplicatePages'
import { withRouter } from '../../utils/withRouterCompat'
class FarmUpdate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      deleteConfirmationOpened: false,
    }

    this.onCancel = this.onCancel.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
  }

  onCancel() {
    if (this.props.history.location.state?.from === 'manejo page') {
      this.props.history.goBack()
    } else {
      this.props.history.push('/')
    }
  }

  async onSubmit(payload) {
    recordEvent({
      level: 'info',
      category: 'farm',
      action: 'farm_updated',
      payload: { nome: this.props.farm?.nome },
    })
    // To create
    const usersToAdd = difference(payload.veterinarios, this.props.relatedUsers)
    // To delete
    const usersToDelete = difference(
      this.props.relatedUsers,
      payload.veterinarios,
    )

    //TODO: Check how own user behaves considering Farm__rel__Users
    //(is it omitted, since it's the user who created the farm? or is it added anyway)

    const repository = new Repository(AVAILABLE_ENTITIES.FARMS)
    const request = await repository.update(payload)

    if (request.success) {
      recordSaveOutcome('farm', 'farm_update', 'success', {
        farmId: this.props.farm?.id,
      })

      const farmUserRepository = new Repository(AVAILABLE_ENTITIES.FARM_USERS)
      let success = true
      forEach(usersToAdd, async (user) => {
        const req = await farmUserRepository.post({
          idFazenda: this.props.farm.id,
          idUsuario: user.id,
        })
        if (!req.success) {
          success = false
        }
      })

      const existingEntriesReq = await farmUserRepository.getByParam(
        'farm_id',
        this.props.farm.id,
      )
      if (
        existingEntriesReq.success &&
        existingEntriesReq.response.length > 0
      ) {
        const existingEntries = existingEntriesReq.response
        forEach(usersToDelete, async (user) => {
          //Skipping user with e-mail velocia@admin.com until we have a better understanding of what it is doing
          if (user.email === 'velocia@admin.com') {
            return
          }
          const entry = find(existingEntries, { idUsuario: user.id })
          const req = await farmUserRepository.delete(entry.id)
          if (!req.success) {
            success = false
          }
        })
      }

      if (success) {
      } else {
      }

      if (this.props.history.location.state?.from === 'manejo page') {
        this.props.history.goBack()
      } else {
        this.props.history.push('/')
      }
    } else {
      recordError(
        request.exception instanceof Error
          ? request.exception
          : new Error(String(request.exception ?? 'unknown')),
        {
          category: 'farm',
          action: 'farm_update_failed',
          payload: { farmId: this.props.farm?.id },
        },
      )
    }
  }

  async handleDelete() {
    recordEvent({
      level: 'warn',
      category: 'farm',
      action: 'farm_deleted',
      payload: { farmId: this.props.farm.id },
    })
    const repository = new Repository(AVAILABLE_ENTITIES.FARMS)
    const request = await repository.delete(
      this.props.farm && this.props.farm.id,
    )

    if (request.success) {
      recordSaveOutcome('farm', 'farm_delete', 'success', {
        farmId: this.props.farm?.id,
      })
      this.props.history.push('/')
    } else {
      recordError(
        request.exception instanceof Error
          ? request.exception
          : new Error(String(request.exception ?? 'unknown')),
        {
          category: 'farm',
          action: 'farm_delete_failed',
          payload: { farmId: this.props.farm?.id },
        },
      )
      this.setState({
        deleteConfirmationOpened: false,
      })
    }
  }

  confirmDelete() {
    this.setState({
      deleteConfirmationOpened: true,
    })
  }

  handleBackToManejo = () => this.props.history.goBack()

  getButtons() {
    if (this.props.history.location.state?.from === 'manejo page') {
      return [
        {
          onClick: this.handleBackToManejo,
          label: `Voltar ao manejo`,
        },
      ]
    } else {
      return [
        {
          onClick: this.confirmDelete,
          label: 'Deletar',
          disabled:
            this.props.user.roles[0].name === 'Cliente (somente visualização)',
        },
      ]
    }
  }

  render() {
    const initialValues = {
      nomeProprietario: this.props.farm.nomeProprietario,
      nome: this.props.farm.nome,
      inscricaoEstadual: this.props.farm.inscricaoEstadual,
      pais: this.props.farm.pais,
      estado: this.props.farm.estado,
      municipio: this.props.farm.municipio,
      sistemaProducao: this.props.farm.sistemaProducao,
      tamanho: this.props.farm.tamanho,
      retiro: find(
        [
          { label: 'Sim', value: true },
          { label: 'Não', value: false },
        ],
        { value: this.props.farm.retiro },
      ),
      inicioEstacaoMonta: this.props.farm.inicioEstacaoMonta,
      fimEstacaoMonta: this.props.farm.fimEstacaoMonta,
      estacaoMonta: this.props.farm.estacaoMonta,
      veterinarios: this.props.relatedUsers || [this.props.user],
    }

    return (
      <AppContent>
        <TopBar title={formatName(this.props.farm.nome, FAZENDA)} />
        <TitleBar
          title={formatName(this.props.farm.nome, FAZENDA)}
          buttons={this.getButtons()}
          paths={[
            {
              label: formatName(this.props.farm.nome, FAZENDA),
            },
          ]}
        />
        <FarmForm
          initialValues={initialValues}
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          farm={this.props.farm}
          user={this.props.user}
          disabled={
            this.props.history.location.state?.from === 'manejo page'
              ? true
              : false
          }
        />

        <Prompt
          visible={verify()}
          title='Página duplicada!'
          message={`Para evitar uma possível perda de dados, não é permitido abrir o Progerar em mais de uma aba!
            Para continuar utilizando, feche esta página e volte para utilizar a anterior.`}
          buttons={[
            {
              autoFocus: false,
            },
          ]}
        />

        <Prompt
          visible={this.state.deleteConfirmationOpened}
          title='Confirmar Exclusão'
          message='Você está prestes a deletar esta fazenda. Esta ação não poderá ser desfeita.'
          buttons={[
            {
              label: 'Cancelar',
              onClick: () => this.setState({ deleteConfirmationOpened: false }),
            },
            {
              label: 'Confirmar',
              onClick: this.handleDelete,
            },
          ]}
        />
      </AppContent>
    )
  }
}

const propsFromDatabase = async (props) => ({
  farm: await utils.getElement(AVAILABLE_ENTITIES.FARMS, props.match.params.id),
  relatedUsers: await utils.getWithRelation(
    AVAILABLE_ENTITIES.USERS,
    'farms__rel__users',
    'farm_id',
    props.match.params.id,
  ),
  user: await utils.getElement(
    AVAILABLE_ENTITIES.USERS,
    (await getLoggedUser()).userId,
  ),
})

export default utils.withPropsFromDatabase(
  propsFromDatabase,
  withRouter(FarmUpdate),
)
